import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Icon, Button, Popup } from "semantic-ui-react";
import TablePageHolder from "components/TablePageHolder/TablePageHolder";
import {
  selectTableStructuredData,
  selectInProgressTableStructuredData,
  activeItemSelector,
  generalTasksFilterOptions
} from "selectors/workingTime";
import {
  fetchGeneralTask,
  setActiveItemId,
  setActiveTab,
  updateWorkingTimeStatus,
  deleteWorkingTime,
  deleteWorkingTimes
} from "actions/WorkingTime";
import { fetchGeneralTasksIDs } from "actions/Tasks";
import styles from "./WorkingTime.module.css";
import { Chip } from "routes/Reports/Harvest/components/Chip";
import { StatusChip } from "./components/StatusChip";
import { uniq } from "lodash";
import doubleCheck from "assets/img/doubleCheck.svg";
import Sidebar from "./SideBar/completed/Sidebar";
import InprogressSidebar from "./SideBar/inprogress/Sidebar";
import ClockOut from "./modal/ClockOut/ClockOut";
import ClockIn from "./modal/ClockIn/ClockIn";
import AddInterval from "./modal/AddInterval/AddInterval";
import { employeeViewer } from "routes/Tasks/components/helper";
import DateRangeSelect from "components/Table/components/Filters/DateRangeSelect";
import { farmsOptionsFilterSelector } from "selectors/farms";
import { areaFilterOptions } from "selectors/areas";
import filterTypes from "components/Table/filterTypes";
import { getFarmsList } from "actions/Farms/farms";
import { seasonsOptionsSelector } from "selectors/seasonsSelector";
import ConfirmationModal from "./components/ConfirmationModal";

const WorkingTime = ({
  navigate,
  location,
  route,
  employees,
  activeItem,
  areas,
  farms,
  pageActiveTab,
  isFetching,
  isFetchingClockIn
}) => {
  const dispatch = useDispatch();
  const [clockOutOpen, setClockOutOpen] = useState(false);
  const [forWtAdd, setForWtAdd] = useState(false);
  const [clockIn, setClockIn] = useState(false);
  const [clockOutValue, setClockOutValue] = useState(false);
  const [addInterval, setAddInterval] = useState(false);
  const [activeTab, setactiveTab] = useState(pageActiveTab);
  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [subRowsIndex, setSubRowsIndex] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [workingTimesToDelete, setWorkingTimesToDelete] = useState([]);
  const [params, setParams] = useState([]);
  const [filters, setFilters] = useState({
    cropIds: [],
    varietyIds: [],
    blockIds: [],
    patchIds: [],
    harvestUnitIds: [],
    seasons: [],
    from: "",
    to: ""
  });
  const [open, setOpen] = useState(false);
  const [expandedRow, setExpandedRow] = useState(false);

  const handleItemClick = async (e, { name }) => {
    name !== activeTab && setactiveTab(name);
    await dispatch(setActiveTab(name));
  };

  const getData = useCallback(
    params => {
      setParams(params);
      const workingTimeCompleted = pageActiveTab === "COMPLETED" ? true : false;
      dispatch(fetchGeneralTask(params, pageActiveTab, workingTimeCompleted));

      dispatch(setActiveItemId(null));
    },
    [dispatch, activeTab]
  );

  const onRowClick = useCallback(
    (event, row) => {
      if (row.original.rowInfo === "totalRow" && !row.original.employees.length)
        return;

      setSubRowsIndex(
        row.original.rowInfo === "totalRow" ? "totalRow" : row.index
      );

      if (
        !activeItem &&
        row &&
        !event.target.closest(".gtId-cell") &&
        event.target.id !== "btn"
      ) {
        dispatch(setActiveItemId(row.original.id));
        setSideBarOpen(true);
      }
    },
    [activeItem, dispatch]
  );

  const approvedWorkingTime = wtId => {
    dispatch(updateWorkingTimeStatus(wtId));
  };
  const tableData = useSelector(selectTableStructuredData);
  const inProgressTableDataSelector = useSelector(
    selectInProgressTableStructuredData
  );

  const handleOnDeleteWorkingTime = async () => {
    if (workingTimesToDelete.length === 1) {
      await dispatch(deleteWorkingTime(workingTimesToDelete[0]));
    } else {
      await dispatch(deleteWorkingTimes(workingTimesToDelete));
    }

    setOpenConfirmationModal(false);

    dispatch(fetchGeneralTask(params, pageActiveTab, true));
  };

  useEffect(() => {
    return setExpandedRow(false);
  }, [inProgressTableDataSelector.number, tableData.number]);

  useEffect(() => {
    dispatch(fetchGeneralTasksIDs());

    !farms && !farms?.length && dispatch(getFarmsList());
  }, []);

  const completedTableData = [
    {
      accessor: "gtId",
      id: "expander",
      Header: () => (
        <div
          style={{
            height: "64px",
            paddingLeft: `${1.2}rem`,
            paddingTop: "21px"
          }}
        >
          ID
        </div>
      ),
      withSort: false,
      Cell: ({ value, row }) => {
        return row.canExpand ? (
          <span
            {...row.getToggleRowExpandedProps({
              style: {
                paddingLeft: `${0.1}rem`
              }
            })}
            className="gtId-cell"
          >
            <Icon
              onClick={e => {
                setExpandedRow(row.id);
              }}
              name={`angle ${row.isExpanded ? "up" : "down"}`}
            />
            {value}
          </span>
        ) : row.depth === 1 ? (
          <span
            style={{ paddingLeft: `${1.2}rem` }}
            className="gtId-cell"
          ></span>
        ) : (
          <span style={{ paddingLeft: `${1.2}rem` }} className="gtId-cell">
            {value}
          </span>
        );
      },
      cellWidth: 2,
      minWidth: 280,
      filterId: "seasons",
      filter: {
        title: "Season",
        type: filterTypes.SingleSelect,
        selector: seasonsOptionsSelector
      }
    },
    {
      Header: "Task name",
      id: "taskName",
      withSort: false,
      accessor: "taskName",
      cellWidth: 2,
      Cell: ({ value }) => value,
      filterId: "date",
      filter: {
        title: "Date",
        type: filterTypes.DateRangeSelect,
        selector: <DateRangeSelect loading={isFetching} />
      }
    },
    {
      Header: "Type",
      id: "type",
      withSort: false,
      accessor: "type",
      cellWidth: 2,
      Cell: ({ value }) => value,
      filterId: "farmId",
      filter: {
        title: "Farm",
        type: filterTypes.MultiSelect,
        selector: farmsOptionsFilterSelector
      }
    },
    {
      Header: "Employees",
      id: "employees",
      withSort: false,
      accessor: "employees",
      cellWidth: 2,
      Cell: ({ value }) => {
        if (value.length > 1) {
          const employeeNames = employees
            .filter(({ id }) => value.includes(id))
            .map(({ firstName, lastName }) => `${firstName} ${lastName}`);

          return <Chip label="Employees" items={uniq(employeeNames)} />;
        }

        const employee = employees.find(item => item.id === value[0]);

        return `${employee?.firstName || "—"} ${employee?.lastName || ""}`;
      },
      filterId: "areaId",
      filter: {
        title: "Area",
        type: filterTypes.MultiSelect,
        selector: areaFilterOptions
      }
    },
    {
      Header: "Added by",
      id: "createdBy",
      withSort: false,
      accessor: "createdBy",
      cellWidth: 2,
      Cell: ({ value }) => {
        return employeeViewer(value, employees);
      },
      filterId: "ids",
      filter: {
        title: "Task Id",
        type: filterTypes.MultiSelect,
        selector: generalTasksFilterOptions
      }
    },
    {
      Header: "Total working time",
      id: "totalWorkingTime",
      withSort: false,
      accessor: "totalWorkingTime",
      cellWidth: 2,
      Cell: ({ value }) => {
        if (value) {
          const hours = Math.floor(value);
          const minutes = Math.round((value - hours) * 60);
          return `${hours}h ${minutes}m`;
        }

        return "—";
      }
    },
    {
      Header: "Status",
      id: "approved",
      withSort: false,
      accessor: "approved",
      cellWidth: 2,
      Cell: ({ row, value }) => {
        if (row.original.rowInfo === "totalRow" && !row.original.wtId.length) {
          return "—";
        }

        return <StatusChip approved={value} />;
      }
    },
    {
      Header: "",
      id: "buttonWrapper",
      withSort: false,
      accessor: "buttonWrapper",
      cellWidth: 2,
      Cell: ({ row, value }) => {
        if (row.original.rowInfo === "totalRow" && !row.original.wtId.length) {
          return "—";
        }

        return (
          <div className={styles.btnWrapper} id="btn">
            <Popup
              inverted
              position="bottom center"
              content={"Edit"}
              size="tiny"
              trigger={
                <div className={styles.editButtonWrapper}>
                  <Button
                    onClick={() => {
                      return (
                        setClockOutOpen(true),
                        dispatch(setActiveItemId(row?.original?.id))
                      );
                    }}
                    className={styles.editButton}
                    floated="right"
                    icon={<Icon name="edit" />}
                    size="small"
                  />
                </div>
              }
            />

            {!value ? (
              <Popup
                inverted
                position="bottom center"
                content={"Complete"}
                size="tiny"
                trigger={
                  <div className={styles.checkMarkWrapper}>
                    <Button
                      onClick={() => approvedWorkingTime(row.original.wtId)}
                      className={styles.checkMark}
                      floated="right"
                      icon={<Icon id="btn" name="check" />}
                      size="small"
                    />
                  </div>
                }
              />
            ) : (
              <img
                id="btn"
                className={styles.doubleCheck}
                src={doubleCheck}
                alt="Drag icon"
              />
            )}

            <Popup
              inverted
              position="bottom center"
              content={"Delete"}
              size="tiny"
              trigger={
                <div className={styles.deleteButton}>
                  <Icon
                    name="trash alternate"
                    onClick={e => {
                      e.stopPropagation();
                      setWorkingTimesToDelete(row.original.wtId);
                      setOpenConfirmationModal(true);
                    }}
                  />
                </div>
              }
            />
          </div>
        );
      }
    }
  ];

  const inProgressTableData = [
    {
      accessor: "gtId",
      id: "expander",
      Header: () => (
        <div
          style={{
            height: "64px",
            paddingLeft: `${1.2}rem`,
            paddingTop: "21px"
          }}
        >
          ID
        </div>
      ),
      withSort: false,
      Cell: ({ value, row }) => {
        return row.canExpand ? (
          <span
            {...row.getToggleRowExpandedProps({
              style: {
                paddingLeft: `${0.1}rem`
              }
            })}
            className="gtId-cell"
          >
            <Icon
              onClick={e => {
                setExpandedRow(row.id);
              }}
              name={`angle ${row.isExpanded ? "up" : "down"}`}
            />
            {value}
          </span>
        ) : row.depth === 1 ? (
          <span
            style={{ paddingLeft: `${1.2}rem` }}
            className="gtId-cell"
          ></span>
        ) : (
          <span style={{ paddingLeft: `${1.2}rem` }} className="gtId-cell">
            {value}
          </span>
        );
      },
      cellWidth: 2,
      minWidth: 280,
      filterId: "seasons",
      filter: {
        title: "Season",
        type: filterTypes.SingleSelect,
        selector: seasonsOptionsSelector
      }
    },
    {
      Header: "Task name",
      id: "taskName",
      withSort: false,
      accessor: "taskName",
      cellWidth: 3,
      Cell: ({ value }) => value,
      filterId: "date",
      filter: {
        title: "Date",
        type: filterTypes.DateRangeSelect,
        selector: <DateRangeSelect loading={isFetching || isFetchingClockIn} />
      }
    },
    {
      Header: "Type",
      id: "type",
      withSort: false,
      accessor: "type",
      cellWidth: 2,
      Cell: ({ value }) => value,
      filterId: "farmId",
      filter: {
        title: "Farm",
        type: filterTypes.MultiSelect,
        selector: farmsOptionsFilterSelector
      }
    },
    {
      Header: "Areas",
      id: "areas",
      withSort: false,
      accessor: "areaIds",
      cellWidth: 2,
      Cell: ({ row, value }) => {
        return value.length > 1 && row.original.rowInfo !== "subRows"
          ? value.length
          : areas
              .filter(item => value.includes(item.id))
              .map(a => a.name)
              ?.join(", ");
      },
      filterId: "areaId",
      filter: {
        title: "Area",
        type: filterTypes.MultiSelect,
        selector: areaFilterOptions
      }
    },
    {
      Header: "Employees",
      id: "employees",
      withSort: false,
      accessor: "employees",
      cellWidth: 3,
      Cell: ({ value }) => {
        if (value.length > 1) {
          const employeeNames = employees
            .filter(({ id }) => value.includes(id))
            .map(({ firstName, lastName }) => `${firstName} ${lastName}`);

          return <Chip label="Employees" items={uniq(employeeNames)} />;
        }

        const employee = employees.find(item => item.id === value[0]);

        return `${employee?.firstName || "—"} ${employee?.lastName || ""}`;
      },
      filterId: "ids",
      filter: {
        title: "Task Id",
        type: filterTypes.MultiSelect,
        selector: generalTasksFilterOptions
      }
    },
    {
      Header: "Added by",
      id: "createdBy",
      withSort: false,
      accessor: "createdBy",
      cellWidth: 2,
      Cell: ({ value }) => {
        return employeeViewer(value, employees);
      }
    },
    {
      Header: "",
      id: "buttonWrapper",
      withSort: false,
      accessor: "buttonWrapper",
      cellWidth: 2,
      Cell: ({ row, value }) => {
        return (
          <Button
            id="btn"
            className={
              value === "totalRow"
                ? styles.totalClockOutBtn
                : styles.clockOutBtn
            }
            onClick={() => {
              return (
                setForWtAdd(true),
                value === "subRows" && setClockOutValue(row.id),
                dispatch(setActiveItemId(row?.original?.id)),
                setClockOutOpen(true)
              );
            }}
          >
            Clock Out
          </Button>
        );
      }
    }
  ];

  const columnsConfig = useMemo(
    () =>
      activeTab === "IN_PROGRESS" ? inProgressTableData : completedTableData,
    [filters, employees, activeTab]
  );

  return (
    <>
      {clockOutOpen && (
        <ClockOut
          workingTimeCompleted={pageActiveTab === "COMPLETED"}
          params={params}
          pageActiveTab={pageActiveTab}
          forWtAdd={forWtAdd}
          setForWtAdd={setForWtAdd}
          subRowsIndex={subRowsIndex}
          setSubRowsIndex={setSubRowsIndex}
          setSideBarOpen={setSideBarOpen}
          onClose={() => {
            setClockOutOpen(false);
            dispatch(setActiveItemId(null));
          }}
          activeItem={activeItem}
        />
      )}

      <ClockIn
        workingTimeCompleted={pageActiveTab === "COMPLETED"}
        params={params}
        pageActiveTab={pageActiveTab}
        open={clockIn}
        onClose={() => {
          setClockIn(false);
          dispatch(setActiveItemId(null));
        }}
      />

      <AddInterval
        params={params}
        workingTimeCompleted={pageActiveTab === "COMPLETED" ? true : false}
        pageActiveTab={pageActiveTab}
        open={addInterval}
        onClose={() => {
          setAddInterval(false);
          dispatch(setActiveItemId(null));
        }}
        activeItem={activeItem}
      />

      <TablePageHolder
        mainButton={
          <div>
            <Button
              primary
              className={styles.clockInButton}
              onClick={() => setClockIn(true)}
            >
              Clock In
            </Button>
            <Button
              primary
              className={styles.addButton}
              onClick={() => setAddInterval(true)}
            >
              Add Interval
            </Button>
            <Button
              primary
              className={styles.addButton}
              onClick={() => navigate("/working_time/bulk_create_intervals")}
            >
              Bulk Create Intervals
            </Button>
          </div>
        }
        sidebarShown={sideBarOpen}
        rowId={expandedRow}
        getData={getData}
        isFetching={
          activeTab === "IN_PROGRESS"
            ? inProgressTableDataSelector.isFetching
            : tableData.isFetching
        }
        location={location}
        onRowClick={onRowClick}
        onSidebarHidden={() => {
          return dispatch(setActiveItemId(null));
        }}
        navigate={navigate}
        open={open}
        setSideBarOpen={setSideBarOpen}
        handleItemClick={handleItemClick}
        activeTab={activeTab}
        timeTracking={true}
        setFilters={setFilters}
        setOpen={setOpen}
        pageTitle={route.name}
        route={route}
        tableColumns={columnsConfig}
        withSelection={false}
        withBorder={false}
        tableData={
          activeTab === "IN_PROGRESS" ? inProgressTableDataSelector : tableData
        }
        withoutSort={false}
        firstColumnFixed={false}
        singleLine
        fixed={true}
        sidebarComponent={
          activeTab === "IN_PROGRESS" ? (
            <InprogressSidebar
              setForWtAdd={setForWtAdd}
              employees={employees}
              subRowsIndex={subRowsIndex}
              setSubRowsIndex={setSubRowsIndex}
              setClockOutOpen={setClockOutOpen}
              setSideBarOpen={setSideBarOpen}
              clockOutValue={clockOutValue}
              activeItem={activeItem}
              setActiveItemId={setActiveItemId}
            />
          ) : (
            <Sidebar
              employees={employees}
              subRowsIndex={subRowsIndex}
              setSubRowsIndex={setSubRowsIndex}
              setClockOutOpen={setClockOutOpen}
              setSideBarOpen={setSideBarOpen}
              activeItem={activeItem}
              setActiveItemId={setActiveItemId}
            />
          )
        }
      />

      <ConfirmationModal
        open={openConfirmationModal}
        setOpen={setOpenConfirmationModal}
        workingTimes={workingTimesToDelete}
        onConfirm={handleOnDeleteWorkingTime}
      />
    </>
  );
};

export default connect((state, props) => {
  return {
    pageActiveTab: state.workingTimes.activeTab.tab,
    areas: state.areas.list.content,
    farms: state.farms.summary,
    employees: [
      ...state.employee.list.content,
      ...state.employee.archivedList.content
    ],
    filterValues: state.packedBoxes.filters,
    isFetching: state.workingTimes.workingTimes.isFetching,
    isFetchingClockIn: state.workingTimes.clockIn.isFetching,
    activeItem: activeItemSelector(state),
    error: state.packedBoxes.error
  };
})(WorkingTime);
